var map = {
	"./arrow-down.svg": 1087,
	"./arrow-right.svg": 1088,
	"./card-list.svg": 1089,
	"./card.svg": 1090,
	"./file.svg": 1091,
	"./home-light.svg": 1092,
	"./home.svg": 1093,
	"./love.svg": 1094,
	"./my-light.svg": 1095,
	"./my.svg": 1096,
	"./patient-light.svg": 1097,
	"./patient.svg": 1098,
	"./qr.svg": 1099,
	"./zoom.svg": 1100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1086;